import { onMounted, onUnmounted } from 'vue';

import { useRaf } from '@resn/gozer-vue';

const MAX_DELTA_TIME = 100;

// from @resn/gozer-math and @resn/gozer-animation
const lerp = (value, min, max) => {
    return min + value * (max - min);
};
const damp = (a, b, lambda, dt) => {
    return lerp(1 - Math.exp(-lambda * dt), a, b);
};

export const useDamp = (target, config = {}, targetValues = []) => {
    const state = {
        properties: {},
        config: {
            lambda: 3,
            ...config,
        },
    };

    const newProperty = (key) => {
        state.properties[key] = {
            current: target[key],
            to: target[key],
            velocity: 0,
        };
    };

    const props = targetValues.length ? { ...targetValues } : target;

    if (targetValues.length)
        for (let i = 0; i < targetValues.length; i++) {
            const key = targetValues[i];
            newProperty(key);
        }
    else
        for (const key in props) {
            if (Object.hasOwnProperty.call(target, key)) newProperty(key);
        }

    const update = ({ delta: dt }) => {
        const { lambda } = state.config;

        for (const key in state.properties) {
            const prop = state.properties[key];
            const { current, to } = prop;

            const dtCapped = Math.min(dt, MAX_DELTA_TIME);
            const dt_ms = dtCapped / 1000;

            prop.velocity = to - current;
            prop.current = damp(prop.current, prop.to, lambda, dt_ms);

            if (Math.abs(prop.velocity) < 0.0001) prop.current = prop.to;

            target[key] = prop.current;
        }
    };
    const { stop, start, isActive: activeTick } = useRaf(update, { immediate: false });
    const set = (props, force = false) => {
        for (const key in props) {
            if (Object.hasOwnProperty.call(state.properties, key)) {
                state.properties[key].to = props[key];
                if (force) state.properties[key].current = props[key];
            }
        }
    };
    const toggle = () => (activeTick.value ? stop() : start());
    const onVisibilityChange = () => (document.visibilityState === 'visible' ? start() : stop());

    onMounted(() => {
        start();
        document.addEventListener('visibilitychange', onVisibilityChange);
    });
    onUnmounted(() => {
        stop();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });

    return {
        start,
        stop,
        state,
        toggle,
        set,
        update,
    };
};
